// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"06559e34","297":"0cb7e678","496":"3e8c7bbe","643":"42a79e93"}[chunkId] + ".chunk.js";
};